export default{
    inserted(el) {
        if (el.focus && el.select) {
            el.focus();
            setTimeout(() => el.select(), 100);
        } else {
            const childElement = el.querySelector('input');
            if (childElement) {
                childElement.focus();
                setTimeout(() => childElement.select(), 100);
            } else {
                console.error('No focusable element found');
            }
        }
    }
}
